import PropTypes from 'prop-types';
import { ITEM_TYPE } from '@eventbrite/eds-data-table-list-item';

export const ITEMS_PROP_TYPE = PropTypes.arrayOf(ITEM_TYPE);

export const SELECTED_ITEMS_PROP_TYPE = PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
);

export const HIGHLIGHTED_ITEMS_PROP_TYPE = PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
);

export const DISABLED_ITEMS_PROP_TYPE = PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
);
